export default "/images/vendor/flag-icon-css/flags/4x3/mg.svg?04eb8444d01a184fbd1d789210b09a78";